export const AuthStateModuleName = 'authStateModule'
export const ConfigStateModuleName = 'configStateModule'
export const NotificationModuleName = 'notificationModule'
export const ModalStateModuleName = 'modalStateModule'
export const FrameStateModuleName = 'frameStateModule'

export const ReviewRequestModuleName = 'reviewRequestModule'

export const OpenReviewEntryModuleName = 'openReviewEntryModule'
export const CloseReviewEntryModuleName = 'closeReviewEntryModule'
export const ReviewPageStateModuleName = 'reviewPageStateModule'
export const ReviewEntryDetailModuleName = 'reviewEntryDetailModule'

export const OpenReviewPostEntryModuleName = 'openReviewPostEntryModule'
export const ReviewPostPageStateModuleName = 'reviewPostPageStateModule'
export const ReviewPostEntryDetailModuleName = 'reviewPostEntryDetailModule'
export const PostReviewModuleName = 'postReviewModule'

export const ModelAnswerListModuleName = 'modelAnswerListModule'
export const ModelAnswerSourceCodeModuleName = 'modelAnswerSourceCodeModule'
export const ModelAnswerPageStateModuleName = 'modelAnswerPageStateModule'

export const HistoryListModuleName = 'historyListModule'
export const HistorySourceCodeModuleName = 'historySourceCodeModule'
export const HistoryPageStateModuleName = 'historyPageStateModule'

export const EditorPageStateModuleName = 'editorPageStateModule'

export const PostTestSubmissionModuleName = 'postTestSubmissionModule'
export const PostSubmissionModuleName = 'postSubmissionModule'
export const PostArenaSubmissionModuleName = 'postArenaSubmissionModule'
export const JudgeStateModuleName = 'judgeStateModule'
export const JudgeDetailModuleName = 'judgeDetailModule'
export const JudgeReferenceModuleName = 'judgeReferenceModule'
export const RecentJudgeListModuleName = 'recentJudgeListModule'

export const TestCaseModuleName = 'testCaseModule'
export const JudgeCaseModuleName = 'judgeCaseModule'

export const judgeDetailPageStateModuleName = 'judgeDetailPageStateModule'

export const FreeSpaceJudgeDetailModuleName = 'freeSpaceJudgeDetailModule'
export const FreeSpaceStateModuleName = 'freeSpaceStateModule'

export const ProblemStateModuleName = 'problemStateModule'
export const ProblemDescriptionModuleName = 'problemDescriptionModule'
export const ProblemStatisticsModuleName = 'problemStatisticsModule'
export const ProblemSearchModalStateModuleName = 'problemSearchModalStateModule'
export const CourseModuleName = 'courseModule'
export const ChallengeModuleName = 'challengeModule'
export const BookmarkModuleName = 'bookmarkModule'
export const CourseStatisticsModuleName = 'courseStatisticsModule'

export const CommentaryPageStateModuleName = 'commentaryPageStateModule'
export const GetCommentaryModuleName = 'getCommentaryModule'

export const ArenaModuleName = 'arenaModule'

export const DashboardModalStateModuleName = 'dashboardModalStateModule'
export const StatisticsModuleName = 'statisticsModule'
export const WeeklyRatingModuleName = 'weeklyRatingModule'
export const CategoryRatingModuleName = 'categoryRatingModule'
export const HeatMapModuleName = 'heatMapModule'
export const CourseHeatMapModuleName = 'courseHeatMapModule'

export const LanguageStatisticsModuleName = 'languageStatisticsModule'
export const DailyEffortsModuleName = 'dailyEffortsModule'
export const SolvedProblemsModuleName = 'solvedProblemsModule'
export const SubmissionStatusModuleName = 'submissionStatusModule'
export const WhatCategoryRatingModuleName = 'whatCategoryRatingModule'
export const HowCategoryRatingModuleName = 'howCategoryRatingModule'
export const ProgrammingCategoryRatingModuleName = 'programmingCategoryRatingModule'
